"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OCPI_GENERIC_CODES = exports.ELECTRIC_ERA_COUNTRY_CODE = exports.ELECTRIC_ERA_PARTY_ID = exports.CPO_LOGO_URL = exports.HOURS_TO_MILLISECONDS = exports.MINUTES_TO_MILLISECONDS = exports.SECONDS_TO_MILLISECONDS = exports.OCPI_GENERIC_SUCCESS_STATUS_CODE = exports.CUSTOMER_SERVICE_PHONE_NUMBER = exports.KWH_PRECISION = void 0;
// The precision we display on all driver-facing UIs. This is required to comply with CTEP which mandates at least 4 digits of precision.
exports.KWH_PRECISION = 4;
// The customer service phone number.
exports.CUSTOMER_SERVICE_PHONE_NUMBER = "(888) 409-2980";
exports.OCPI_GENERIC_SUCCESS_STATUS_CODE = 1000;
exports.SECONDS_TO_MILLISECONDS = 1000;
exports.MINUTES_TO_MILLISECONDS = 60 * exports.SECONDS_TO_MILLISECONDS;
exports.HOURS_TO_MILLISECONDS = 60 * exports.MINUTES_TO_MILLISECONDS;
exports.CPO_LOGO_URL = "https://electriceradev1.blob.core.windows.net/images/EE-Logo.png";
exports.ELECTRIC_ERA_PARTY_ID = "ECE";
exports.ELECTRIC_ERA_COUNTRY_CODE = "US";
var OCPI_GENERIC_CODES;
(function (OCPI_GENERIC_CODES) {
    OCPI_GENERIC_CODES[OCPI_GENERIC_CODES["SUCCESS"] = 1000] = "SUCCESS";
    OCPI_GENERIC_CODES[OCPI_GENERIC_CODES["CLIENT_ERROR"] = 2000] = "CLIENT_ERROR";
    OCPI_GENERIC_CODES[OCPI_GENERIC_CODES["SERVER_ERROR"] = 3000] = "SERVER_ERROR";
})(OCPI_GENERIC_CODES = exports.OCPI_GENERIC_CODES || (exports.OCPI_GENERIC_CODES = {}));
